// MARK: React
import * as React from "react";
import "./style.scss";

// MARK: Mobx
import { observer } from "mobx-react";

// MARK: Material-UI
import { TableCell as MTableCell } from "@material-ui/core";
import { TableHead as MTableHead } from "@material-ui/core";
import { TableRow as MTableRow } from "@material-ui/core";

// MARK: Resources
import strings from "../../../resources/strings";

interface IProps {
	header: string[];
	hasEdit: boolean;
	hasDelete: boolean;
}

@observer
export default class TableHeader extends React.Component<IProps> {
	public render() {
		const { header, hasEdit, hasDelete } = this.props;

		return (
			<MTableHead>
				<MTableRow>
					{
						hasEdit && hasDelete ? (
							<MTableCell
								key={"header_cell_editAndDelete"}
								align="center"
							>
								{strings.components.table.editAndDelete}
							</MTableCell>
						) :
							hasEdit ? (
								<MTableCell
									key={"header_cell_edit"}
									align="center"
								>
									{strings.components.table.edit}
								</MTableCell>
							) :
								hasDelete ? (
									<MTableCell
										key={"header_cell_delete"}
										align="center"
									>
										{strings.components.table.delete}
									</MTableCell>
								) : <></>
					}
					{
						header.map((headerItem, index) => (
							<MTableCell
								key={"header_cell_" + index}
								align="center"
							>
								{headerItem}
							</MTableCell>
						))
					}
				</MTableRow>
			</MTableHead>
		);
	}
}
